import { decode } from '@googlemaps/polyline-codec';
import React, { useMemo } from 'react';
import { Polyline } from 'react-leaflet';
import { colorForIndex } from 'features/Responder/features/ResponderMap/utils/routeColors';

const normalizePositions = (tour) => {
  if (!tour) return null;
  if (tour.encodedPolyline) return decode(tour.encodedPolyline);
  if (Array.isArray(tour.polyline) && tour.polyline.length) return tour.polyline;
  if (Array.isArray(tour?.legs)) {
    const legWithPolyline = tour.legs.find((leg) => leg?.polyline);
    if (legWithPolyline?.polyline) return decode(legWithPolyline.polyline);
  }
  if (Array.isArray(tour?.stops)) {
    const coords = tour.stops
      .map((s) =>
        Array.isArray(s?.coordinates)
          ? s.coordinates
          : [Number(s.lat ?? s.latitude), Number(s.lng ?? s.longitude)],
      )
      .filter((pt) => Array.isArray(pt) && Number.isFinite(pt[0]) && Number.isFinite(pt[1]));
    return coords.length ? coords : null;
  }
  return null;
};

const getPathOptions = (color) => ({ color, weight: 4, opacity: 0.8 });

export default function MultiRouteLayer({
  tours = [],
  selectedTourIds = [],
  activeTourId = null,
  colorMap = null,
}) {
  const selected = useMemo(() => {
    const keys = selectedTourIds.map((id) => `${id}`);
    return tours.filter((gt) => keys.includes(`${gt.id}`) && `${gt.id}` !== `${activeTourId}`);
  }, [activeTourId, tours, selectedTourIds]);

  return selected.map((tour, idx) => {
    const positions = normalizePositions(tour);
    if (!positions?.length) return null;
    const color = colorMap?.get?.(`${tour.id}`) ?? colorForIndex(idx + 1); // offset to differ from active default
    return (
      <Polyline
        key={`selected-tour-${tour.id}`}
        positions={positions}
        pathOptions={getPathOptions(color)}
      />
    );
  });
}
